import PropTypes from "prop-types";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";

type WorkforceLinkProps = {
  children?: ReactNode;
  item?: { name?: string };
  className?: string;
};

const WorkforceLink = ({ children, item, className }: WorkforceLinkProps) => (
  <Restricted>
    <Link
      id="workforce-nav-link"
      to={url(PATHS.WORKFORCE_ROOT)}
      aria-label={item?.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

WorkforceLink.propTypes = {
  item: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default WorkforceLink;
